import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'ngx-register-options',
  templateUrl: './register-options.component.html',
  styleUrls: ['./register-options.component.scss']
})
export class RegisterOptionsComponent implements OnInit {

  constructor(protected router: Router,) { }

  ngOnInit(): void {
  }

  registerAs(type){
    if(type == 'student'){
      this.router.navigateByUrl('/auth/register');
    }else if(type == 'agent'){
      this.router.navigateByUrl('/auth/registerAgent');
    }
  }
}
